export default __webpack_public_path__ + "static/media/chani fun.c99009fd.svg";